<template>
    <div>
        <!-- tab -->
        <div class="navbox">
            <div class="nav">
                <p :class="{navactived : navtabcurrentindex == index}" @click="handletab(index)" v-for="(change,index) of changeArr" :key="index">{{change.name}}</p>
            </div>
        </div>
        <div class="isloginTips" v-show="loadingShow">
            <img src="@/assets/loading.png" alt="">
            <p>提交中...</p>
        </div>
        <div class="timebox" v-show="timepickershow">
            <div class="timeboxwrapper">
                <div class="title">选择挂单有效期</div>
                <ul>
                    <li>年</li>
                    <li>月</li>
                    <li>日</li>
                    <li>时</li>
                    <li>分</li>
                </ul>
                <van-datetime-picker v-model="currentDate" type="datetime" :min-date="minDate" :max-date="maxDate" @change="onchange" visible-item-count="3" :show-toolbar="false"/>
            </div>
            <div class="timebtn">
                <p @click="confirmremove">取消</p>
                <p @click="confirmPicker">确定</p>
            </div>
        </div>

        <!-- 市价交易 -->
        <div class="content" v-show="this.navtabcurrentindex == 0">
            <p class="contenttips">市价模式下的成交价格，可能会与请求价格有一定差异。</p>

            <div class="price">
                <div class="left">
                    <p>卖出市价</p>
                    <p>{{this.$store.state.silverSell?this.$store.state.silverSell.toFixed(3):'--.--'}}</p>
                </div>
                <div class="main">
                    <p>点差</p>
                    <p>{{spread}}</p>
                </div>
                <div class="right">
                    <p>买入市价</p>
                    <p>{{this.$store.state.silverBuy?this.$store.state.silverBuy.toFixed(3):'--.--'}}</p>
                </div>
            </div>
            <div class="dealbox">
                <div class="left">
                    <p>交易手数</p>
                </div>

                <div class="ctrlbox">
                    <div class="main"><img @click="totalcut" src="@/assets/cut.png" alt=""></div>
                    <div class="right">
                        <span><input type="num" placeholder="手数" v-model.number="initlot" @input="oninput" @focus="onfocuss" @blur="onblur"></span>
                        <span><img @click="totaladd" src="@/assets/add.png" alt=""></span>
                        <span @click="resetnum()">清空</span>
                    </div>
                </div>

            </div>
            <dealprices @zhisunds='getzhisunds' @zhiyingds='getzhiyingds' @silverzhiying='silvermentss' @silverzhisun='silvermentsss' :navtabcurrentindex='navtabcurrentindex' :yfk='yfk' @lotsarr='lotsarrs' :initlot='Number(this.initlot)'></dealprices>
            <div class="buybox">
                <div @click="handleSell" class="sell">市价卖出</div>
                <div @click="handleBuy" class="buy">市价买入</div>
            </div>

            <!-- 市价卖出弹出框 -->
            <div class="mask" v-show="sellBoxShow || buyBoxShow"></div>
            <div class="Sellbox" v-show="sellBoxShow || buyBoxShow">
                <div class="title">确认订单信息</div>
                <div class="sellContent">
                    <div class="top">
                        <span :style="{backgroundColor:sellBoxShow?'#17CF84':(buyBoxShow?'#FF4F36':'#999999')}">{{sellBoxShow?'市价卖出':(buyBoxShow?'市价买入':'请选择')}}</span>  
                        <span>{{this.$store.state.goldindex?'伦敦金':'伦敦银'}}</span>
                        <span>{{initlot+'手'}}</span>
                    </div>
                    <ul>
                        <div class="left">
                            <li>交易价格<span>市价</span></li>
                            <li>最新价格<span>{{this.navtabcurrentindex == 0 && sellBoxShow?parseFloat(this.$store.state.silverSell).toFixed(3):parseFloat(this.$store.state.silverBuy).toFixed(3)}}</span></li>
                        </div>
                        <div class="right">
                            <li>止损<span>{{!this.silverzsds && this.silverzs && this.navtabcurrentindex == 0?parseFloat(this.silverzs).toFixed(3):(this.silverzsds && !this.silverzs && this.navtabcurrentindex == 0 && sellBoxShow?'市价 +'+this.silverzsds:(this.silverzsds && !this.silverzs && this.navtabcurrentindex == 0 && buyBoxShow?'市价 -'+this.silverzsds:'未设置'))}}</span></li>
                            <li>止盈<span>{{!this.silverzyds && this.silverzy && this.navtabcurrentindex == 0?parseFloat(this.silverzy).toFixed(3):(this.silverzyds && !this.silverzy && this.navtabcurrentindex == 0 && sellBoxShow?'市价 -'+this.silverzyds:(this.silverzyds && !this.silverzy && this.navtabcurrentindex == 0 && buyBoxShow?'市价 +'+this.silverzyds:'未设置'))}}</span></li>
                        </div>
                    </ul>
                </div>
                <div class="sellbtn">
                    <p @click="btnremove">取消</p>
                    <p v-preventReClick @click="submit">提交</p>
                </div>
            </div>
        </div>

        <!-- 挂单交易 -->
        <div class="content" v-show="this.navtabcurrentindex == 1">
            <p class="contenttips">挂单模式下行情剧烈波动时，成交价格会更有利或更不利。</p>
            <div class="list">
                <div class="list-item" @click="choosetype">
                    <div class="list-item-left">交易类型</div>
                    <div class="list-item-right">{{choosetext}}<span><img src="@/assets/icon-right.png" alt=""></span></div>
                </div>
                <div @click="handledealdate" class="list-item">
                    <div class="list-item-left">有效期</div>
                    <div class="list-item-right">{{dealdatetext}}<span><img src="@/assets/icon-right.png" alt=""></span></div>
                </div>

                <div class="list-item">
                    <div class="list-item-left">挂单价格<span>{{getDealTypePrice}}</span></div>
                    <div class="list-item-right">
                        <div class="main"><img @click="silvergdcut" src="@/assets/cut.png" alt=""></div>
                        <div class="right">
                            <span><input type="num" placeholder="未设置" v-model.number="silvergdprice" @input='onsilverprice'></span>
                            <span><img @click="silvergdadd" src="@/assets/add.png" alt=""></span>
                            <span @click="silvergdreset">清空</span>
                        </div>
                    </div>
                </div>

                <div class="list-item" v-show="this.$store.state.mt == 5 && showts">
                    <div class="list-item-left">停损限价<span>{{silveryjtsprice}}</span></div>
                    <div class="list-item-right">
                        <div class="main"><img @click="silvergdtscut" src="@/assets/cut.png" alt=""></div>
                        <div class="right">
                            <span><input type="num" placeholder="未设置" v-model.number="silvertsprice" @input='onsilvertsinput'></span>
                            <span><img @click="silvergdtsadd" src="@/assets/add.png" alt=""></span>
                            <span @click="silvertsreset">清空</span>
                        </div>
                    </div>
                </div>

                <div class="list-item">
                    <div class="list-item-left">交易手数</div>
                    <div class="list-item-right">
                        <div class="main"><img @click="gdtotalcut" src="@/assets/cut.png" alt=""></div>
                        <div class="right">
                            <span><input type="num" placeholder="手数" v-model.number="gdinitlot" @input="gdoninput" @focus="gdonfocuss" @blur="gdonblur"></span>
                            <span><img @click="gdtotaladd" src="@/assets/add.png" alt=""></span>
                            <span @click="gdresetnum()">清空</span>
                        </div>
                    </div>
                </div>
            </div>
            <dealprices style="margin-top:12px;"  
            :gdsilverzs='gdsilverzs' 
            :gdsilverzy='gdsilverzy' 
            :gdsilverzyds='gdsilverzyds' 
            :gdsilverzsds='gdsilverzsds' 
            @gdzhiyingds='gdzyds' 
            @gdzhisunds='gdzsds' 
            :navtabcurrentindex='navtabcurrentindex' 
            @silverzhiying='silvermentss' 
            @silverzhisun='silvermentsss' 
            :gdinitlot='Number(this.gdinitlot)' 
            :gdyfk='gdyfk' 
            :silvergdprice='silvergdprice' 
            @gdlotsarr='gdlotsarrs'
            :silvertsprice='silvertsprice' 
            ></dealprices>
            <div @click="handlexd" class="xiadanbtn">下单</div>
            <div style="height:50px"></div>

            <!-- 挂单弹出框 -->
            <div class="mask" v-show="gdshows || choosetypeshow || dateboxshow || timepickershow"></div>
            <div class="Sellbox" v-show="gdshows">
                <div class="title">确认订单信息</div>
                <div class="sellContent">
                    <div class="top">
                        <span :style="{backgroundColor:choosetext == '限价卖出' || choosetext == '止损卖出' || choosetext == '停损限价卖出'?'#17CF84':(choosetext == '限价买入' || choosetext == '止损买入' || choosetext == '停损限价买入'?'#FF4F36':'#999999')}">{{choosetext}}</span>
                        <span>{{this.$store.state.goldindex?'伦敦金':'伦敦银'}}</span>
                        <span>{{gdinitlot+'手'}}</span>
                    </div>
                    <ul>
                        <div class="left">
                            <li>交易价格<span>{{parseFloat(this.silvergdprice).toFixed(3)}}</span></li>
                            <li>最新价格<span>{{choosetext == '限价买入' || choosetext == '止损买入'?this.$store.state.silverBuy.toFixed(3):this.$store.state.silverSell.toFixed(3)}}</span></li>
                            <li v-show="this.$store.state.mt == 5 && showts">停损限价<span>{{parseFloat(silvertsprice).toFixed(3)}}</span></li>
                            <li>有效期:{{dealdatetext}}</li>
                        </div>
                        <div class="right">
                            <li>止损<span>{{navtabcurrentindex == 1 && gdsilverzs?parseFloat(gdsilverzs).toFixed(3):(navtabcurrentindex == 1 && gdsilverzsds?parseFloat(this.getdstopricezs).toFixed(3):'未设置')}}</span></li>
                            <li>止盈<span>{{navtabcurrentindex == 1 && gdsilverzy?parseFloat(gdsilverzy).toFixed(3):(navtabcurrentindex == 1 && gdsilverzyds?parseFloat(this.getdstopricezy).toFixed(3):'未设置')}}</span></li>
                            <li>&nbsp;</li>
                        </div>
                    </ul>
                </div>
                <div class="sellbtn">
                    <p @click="btnremove">取消</p>
                    <p v-preventReClick @click="gdsubmit">提交</p>
                </div>
            </div>

            <!-- 交易类型弹出框 -->
            <div class="mask" v-show="gdshows || choosetypeshow || dateboxshow"></div>
            <div class="chooseTpbox" v-show="choosetypeshow">
                <div class="title">选择交易类型 <img class="close" @click="handleClose" src="@/assets/close.png" alt=""></div>
                <div class="list">
                    <div v-for="(item,index) in choosetypelist" :key="index" class="item" @click="handlechoose(index)">{{item.title}}<img v-show="selectIndex==index?true:false" src="@/assets/correct.png" alt=""></div>
                </div>
            </div>

            <!-- 交易日期弹出框 -->
            <div class="databox" v-show="dateboxshow">
                <div class="title">选择挂单有效期 <img class="close" @click="handleClose" src="@/assets/close.png" alt=""></div>
                <div class="list">
                    <div v-for="(item,index) in datelist" :key="index" class="item" @click="handledate(index)">{{item.title}}<img v-show="dateselectIndex==index?true:false" src="@/assets/correct.png" alt=""></div>
                    <div style="height:56.33px;line-height:56.33px;color:#333333;font-size:16px;border-bottom: 1px solid #F5F5F5" @click="customize()">自定义</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import pako from 'pako'
import {mapState,mapMutations,mapAction,mapGetters} from 'vuex'
import {sldealsj,getsymbol,utf8ByteToUnicodeStr} from '@/utils/socket2.js';
import moment from 'moment'
import dealprices from '@/components/dealprice'
export default {
    inject:['reload'], //注入刷新当前页依赖 来自app.vue
    components:{
        dealprices,
    },
    name:'silvers',
    data(){
        return{
            loadingShow:false,//开启加载提示
            changeArr:[{'name':'市价交易'},{'name':'挂单交易'}],
            yfk:this.$store.state.isprofession?32.5:93.62,//初始参考预付款
            gdyfk:this.$store.state.isprofession?32.5:93.62,//初始挂单参考预付款
            navtabcurrentindex:0,
            // clicktotal:0,//点击总次数
            totallot:20,//最大手数
            initlot:0.05,//初始手数
            gdinitlot:0.05,//挂单初始手数
            num:5, //每次加减的倍数
            sellBoxShow:false,

            silverzy:null,//dealprice传过来的白银止盈价
            silverzs:null,//dealprice传过来的白银止损价
            
            gdsilverzy:null, //dealprice传过来的挂单白银止盈价
            gdsilverzs:null, //dealprice传过来的挂单白银止损价

            buyBoxShow:false,//买入价弹出框
            gdshows:false,//挂单弹出框

            choosetext:'限价买入',//初始交易类型
            choosetypeshow:false, //选择交易类型弹框
            choosetypelist:this.$store.state.mt==5?[{'id':'0','title':'限价买入','type':'0'},{'id':'1','title':'限价卖出','type':'1'},{'id':'2','title':'止损买入','type':'2'},{'id':'3','title':'止损卖出','type':'3'},{'id':'4','title':'停损限价买入','type':'4'},{'id':'5','title':'停损限价卖出','type':'5'}]:[{'id':'0','title':'限价买入','type':'0'},{'id':'1','title':'限价卖出','type':'1'},{'id':'2','title':'止损买入','type':'2'},{'id':'3','title':'止损卖出','type':'3'}],
            selectIndex:0, //交易类型选择

            dealdatetext:'长期有效', //初始交易日期
            dateboxshow:false, //选择交易类型弹框
            datelist:[{'id':'0','title':'长期有效'},{'id':'1','title':'本日有效'},{'id':'2','title':'本周有效'},{'id':'3','title':'本月有效'}],
            dateselectIndex:0, //交易类型选择

            slflag:true,//白银默认
            silvergdprice:null,//白银挂单价格
            silverclicktotal:0,//白银点击总次数

            silverzsds:null,//传过来的市价止损点数
            silverzyds:null,//传过来的市价止盈点数

            gdsilverzsds:null,//传过来的挂单止损点数
            gdsilverzyds:null,//传过来的挂单止盈点数

            slsubmitflag:false,//市价提交请求开关
            gdslsubmitflag:false,//挂单提交请求开关

            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2025, 10, 1),
            currentDate: new Date(),
            timepickershow:false,
            changetime:null,

            silvertsprice:null, //白银停损价格
            tsflag:true,//停损默认
            silverclicktstotal:0,//白银点击总次数

            
            showts:false //是否展示停损限价

        }
    },
    methods:{

        handletab(index){
            this.navtabcurrentindex = index
        },
         // 监听输入框
        oninput(e) {
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            this.initlot = e.target.value
            if(this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.gets(650,'initlot'))
            }else if(!this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.initlot * 100 * this.$store.state.silverBuy)
            }
        },

        onfocuss(e){

            e.target.value=''
            this.initlot = e.target.value
        },

        onblur(e){
            this.initlot = e.target.value

        },

        // 监听挂单输入框
        gdoninput(e) {
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            this.gdinitlot = e.target.value
            if(this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gets(650,'gdinitlot'))
            }else if(!this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 100 * this.silvergdprice)
            }
        },

        gdonfocuss(e){

            e.target.value=''
            this.gdinitlot = e.target.value
        },

        gdonblur(e){
            this.gdinitlot = e.target.value

        },
        
        NumberAdd(arg1, arg2){
            var r1,r2,m,n
            try{
                r1 = arg1.toString().split('.')[1].length
            } catch (e){
                r1 = 0
            }
            try{
                r2 = arg2.toString().split('.')[1].length
            } catch (e){
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2))
            n = ( r1 >= r2 ) ? r1 : r2
            return ((arg1 * m + arg2 * m ) / m ).toFixed(n)
        },

        Sub(arg1, arg2) {
            arg1 = parseFloat(arg1);
            arg2 = parseFloat(arg2);
            var r1, r2, m, n;
            try {
                r1 = arg1.toString().split(".")[1].length
            } catch (e) {
                r1 = 0
            }
            try {
                r2 = arg2.toString().split(".")[1].length
            } catch (e) {
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2));
            //动态控制精度长度
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m ) / m ).toFixed(n)
        },

    // 市价交易手数加减
        totaladd(){
            var lots = 0.05
            this.initlot = this.NumberAdd(this.initlot,lots)

            if(this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.gets(650,'initlot'))
            }else if(!this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.initlot * 100 * this.$store.state.silverBuy)
            }
        },

        totalcut(){
            if(this.initlot <= 0.05){
                this.initlot = 0.05 
                if(this.$store.state.isprofession){
                    this.yfk = Number(this.yfk = this.gets(650,'initlot'))
                }else{
                    this.yfk = Number(this.yfk = this.initlot * 100 * this.$store.state.silverBuy)
                }
                return false
            }
            var lots = 0.05 
            this.initlot = Number(this.Sub(this.initlot,lots))
            if(Number(this.Sub(this.initlot,lots)) <= 0.05){
                this.initlot = '0.05'
            }

            if(this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.gets(650,'initlot'))
            }else if(!this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.initlot * 100 * this.$store.state.silverBuy)
            }
        },
        resetnum(){
            // this.clicktotal = 0
            this.initlot = null
            if(this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.gets(650,'initlot'))
            }else if(!this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.initlot * 100 * this.$store.state.silverBuy)
            }
        },
    // 市价交易手数加减    

    // 挂单手数加减
        gdtotaladd(){
            var lots = 0.05
            this.gdinitlot = this.NumberAdd(this.gdinitlot,lots)

            if(this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gets(650,'gdinitlot'))
            }else if(!this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 100 * this.silvergdprice)
            }
        },

        gdtotalcut(){
            if(this.gdinitlot <= 0.05){
                this.gdinitlot = 0.05
                if(this.$store.state.isprofession){
                    this.gdyfk = Number(this.gdyfk = this.gets(650,'gdinitlot'))
                }else{
                    this.gdyfk = Number(this.gdyfk = this.gdinitlot * 100 * this.silvergdprice)
                }
                return false
            }
            var lots = 0.05 
            this.gdinitlot = Number(this.Sub(this.gdinitlot,lots))
            if(Number(this.Sub(this.gdinitlot,lots)) <= 0.05){
                this.gdinitlot = '0.05'
            }

            if(this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gets(650,'gdinitlot'))
            }else if(!this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 100 * this.silvergdprice)
            }
        },
        gdresetnum(){
            // this.clicktotal = 0
            this.gdinitlot = null
            if(this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gets(650,'gdinitlot'))
            }else if(!this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 100 * this.silvergdprice)
            }
        },
    // 挂单手数加减


        // 获取预付款差值
        gets(val,lot){
            var s = ''
            return s = (this[lot] * val).toFixed(2)
        },


        // 监听白银页面挂单价格输入框
        onsilverprice(e) {
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
            this.silvergdprice = e.target.value
            this.slflag = false
        },
        // 监听白银页面挂单价格输入框

        // 监听白银页面停损价格输入框
        onsilvertsinput(e) {
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
            this.silvertsprice = e.target.value
            this.tsflag = false
        },
        // 监听白银页面停损价格输入框


        silvergdtsadd(){
            var initnum = 0.001
            if(this.silverclicktstotal == 0 && this.tsflag == true){

                this.silvertsprice = Number(this.silveryjtsprice.replace(/<|>/g,''))

            }
            this.silverclicktstotal++
            this.silvertsprice = parseFloat(this.NumberAdd(this.silvertsprice,initnum)).toFixed(3)
        },

        silvergdtscut(){
            var initnum = 0.001
            if(this.silverclicktstotal == 0 && this.tsflag == true){

                this.silvertsprice = Number(this.silveryjtsprice.replace(/<|>/g,''))

            }
            this.silverclicktstotal++
            if(this.silvertsprice <= 0)return false
            this.silvertsprice = parseFloat(this.Sub(this.silvertsprice,initnum)).toFixed(3)
        },

        silvertsreset(){
            this.silvertsprice = null
            this.silverclicktstotal = 0
            this.tsflag = true
        },

        // 挂单白银交易价格加减
        silvergdadd(){
            var initnum = 0.001
            if(this.silverclicktotal == 0 && this.slflag == true){

                if(this.choosetext == '限价买入'){
                    // 买入市价-$0.2
                    this.silvergdprice = this.Sub(this.$store.state.silverBuy,(this.$store.state.silverstopsLevel/1000))
                }else if(this.choosetext == '限价卖出'){
                    // 卖出市价+$0.2
                    this.silvergdprice = this.NumberAdd(this.$store.state.silverSell,(this.$store.state.silverstopsLevel/1000))
                }else if(this.choosetext == '止损买入'){
                    // 买入市价+$0.2
                    this.silvergdprice = this.NumberAdd(this.$store.state.silverBuy,(this.$store.state.silverstopsLevel/1000))
                }else if(this.choosetext == '止损卖出'){
                    // 卖出市价-$0.2
                    this.silvergdprice = this.Sub(this.$store.state.silverSell,(this.$store.state.silverstopsLevel/1000))
                }else if(this.choosetext == "停损限价买入"){
                    // 买入市价+$0.2
                    this.silvergdprice = this.NumberAdd(this.$store.state.silverBuy,(this.$store.state.silverstopsLevel/1000))
                }else if(this.choosetext == "停损限价卖出"){
                    // 卖出市价-$0.2
                    this.silvergdprice = this.Sub(this.$store.state.silverSell,(this.$store.state.silverstopsLevel/1000))
                }

            }
            this.silverclicktotal++
            this.silvergdprice = parseFloat(this.NumberAdd(this.silvergdprice,initnum)).toFixed(3)
        },

        silvergdcut(){
            var initnum = 0.001
            if(this.silverclicktotal == 0 && this.slflag == true){

                if(this.choosetext == '限价买入'){
                    // 买入市价-$0.2
                    this.silvergdprice = this.Sub(this.$store.state.silverBuy,(this.$store.state.silverstopsLevel/1000))
                }else if(this.choosetext == '限价卖出'){
                    // 卖出市价+$0.2
                    this.silvergdprice = this.NumberAdd(this.$store.state.silverSell,(this.$store.state.silverstopsLevel/1000))
                }else if(this.choosetext == '止损买入'){
                    // 买入市价+$0.2
                    this.silvergdprice = this.NumberAdd(this.$store.state.silverBuy,(this.$store.state.silverstopsLevel/1000))
                }else if(this.choosetext == '止损卖出'){
                    // 卖出市价-$0.2
                    this.silvergdprice = this.Sub(this.$store.state.silverSell,(this.$store.state.silverstopsLevel/1000))
                }else if(this.choosetext == "停损限价买入"){
                    // 买入市价+$0.2
                    this.silvergdprice = this.NumberAdd(this.$store.state.silverBuy,(this.$store.state.silverstopsLevel/1000))
                }else if(this.choosetext == "停损限价卖出"){
                    // 卖出市价-$0.2
                    this.silvergdprice = this.Sub(this.$store.state.silverSell,(this.$store.state.silverstopsLevel/1000))
                }

            }
            this.silverclicktotal++
            if(this.silvergdprice <= 0)return false
            this.silvergdprice = parseFloat(this.Sub(this.silvergdprice,initnum)).toFixed(3)

        },

        silvergdreset(){
            this.silvergdprice = null
            this.silverclicktotal = 0
            this.slflag = true
        },
        // 挂单白银交易价格加减


        // 选择交易类型弹出
        choosetype(){
            this.choosetypeshow = true 
        },

        // 选择交易类型
        handlechoose(index){
            this.selectIndex = index
            this.choosetext = this.choosetypelist[index].title

            if(this.choosetext == "停损限价买入" || this.choosetext == "停损限价卖出"){
                this.showts = true
            }else{
                this.showts = false
            }

            this.choosetypeshow = false

            this.silvergdprice = null //每次切换清空挂单价格
            this.silverclicktotal = 0 //每次清空挂单价格都要重置这个属性
            this.slflag = true //每次清空挂单价格都要重置这个属性,因为第一次点击加或减要获取行情价
            this.gdinitlot = null //每次切换清空挂单手数

            this.gdsilverzs = null //每次切换清空挂单止损input
            this.gdsilverzy = null //每次切换清空挂单止盈input
            this.gdsilverzyds = null //每次切换清空挂单点数input
            this.gdsilverzsds = null //每次切换清空挂单点数input

            this.silvertsprice=null, //清空白银停损价格
            this.tsflag=true,//清空白银停损默认
            this.silverclicktstotal=0,//清空白银总点击

            this.$store.state.sldealtype = this.choosetypelist[index].title

        },

        // 弹出交易日期
        handledealdate(){
            this.dateboxshow = true
        },

        // 选择交易日期
        handledate(index){
            this.dateselectIndex = index
            this.dealdatetext = this.datelist[index].title
            this.dateboxshow = false
            if(index == 4){
                
            }
        },

        // 关闭交易类型、交易日期弹出框
        handleClose(){
            this.choosetypeshow = false
            this.dateboxshow = false
        },

        // dealprice子组件传过来的初始手数
        lotsarrs(val){
            this.initlot = val.toFixed(2)
            if(this.$store.state.isprofession){
                this.yfk = Number(this.yfk = this.gets(650,'initlot'))
            }else{
                this.yfk = Number(this.yfk = this.initlot * 100 * this.$store.state.silverBuy)
            }
        },

        // dealprice子组件传过来的挂单初始手数
        gdlotsarrs(val){
            this.gdinitlot = val.toFixed(2)
            if(this.$store.state.isprofession){
                this.gdyfk = Number(this.gdyfk = this.gets(650,'gdinitlot'))
            }else{
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 100 * this.silvergdprice)
            }
        },

        // dealprice子组件传过来的止损价
        silvermentsss(val){
            if(this.navtabcurrentindex == 0){
                this.silverzs = val
                this.silverzs = Number(this.silverzs)
 
            }else if(this.navtabcurrentindex == 1){
 
                this.gdsilverzs = val
                this.gdsilverzs = Number(this.gdsilverzs)

            }
        },

        // dealprice子组件传过来的止盈价
        silvermentss(val){

            if(this.navtabcurrentindex == 0){
                this.silverzy = val
                this.silverzy = Number(this.silverzy)

            }else if(this.navtabcurrentindex == 1){
                this.gdsilverzy = val
                this.gdsilverzy = Number(this.gdsilverzy)
 
            }
        },

        // dealprice子组件传过来的市价止损点数
        getzhisunds(val){
            this.silverzsds = val
        },

        // dealprice子组件传过来的市价止盈点数
        getzhiyingds(val){
            this.silverzyds = val
        },

        // dealprice子组件传过来的挂单止损点数
        gdzsds(val){
            this.gdsilverzsds = val

        },

        // dealprice子组件传过来的挂单止盈点数
        gdzyds(val){
            this.gdsilverzyds = val

        },

        // 点击下单
        handlexd(){
            if(this.gdinitlot <= 0){
                this.$toast('请输入手数')
                return false
            }
            if(this.silvergdprice <= 0){
                this.$toast('请输入正确的价格')
                return false
            }
            if(this.choosetext == "停损限价买入" && !this.silvertsprice){
                this.$toast("请输入停损价格")
                return false
            }
            if(this.choosetext == "停损限价卖出" && !this.silvertsprice){
                this.$toast("请输入停损价格")
                return false
            }
            this.gdshows = true //挂单下单弹框

        },

        // 点击市价卖出
        handleSell(){
            if(this.initlot <= 0){
                this.$toast('请输入手数')
                return false
            }
            this.sellBoxShow = true
            this.buyBoxShow = false
        },

        // 点击市价买入
        handleBuy(){
            if(this.initlot <= 0){
                this.$toast('请输入手数')
                return false
            }
            this.buyBoxShow = true
            this.sellBoxShow = false
        },

        // 点击自定义
        customize(){
            this.timepickershow = true
            this.dateboxshow = false
        },

        // 时间选定
        onchange(val){
            this.changetime = val.getValues()[0]+'-'+val.getValues()[1]+'-'+val.getValues()[2]+' '+val.getValues()[3]+':'+val.getValues()[4]
        },

        // 时间确认
        confirmPicker(){
            if(this.changetime){
                this.dealdatetext = this.changetime
            }
            this.timepickershow = false
            this.dateselectIndex = 999999 //消除选择标志
        },

        // 时间取消
        confirmremove(){
            this.timepickershow = false
        },

        // 开启websocket
        initWebpack(){

            var that = this

 

            if (that.global.ws && that.global.ws.readyState == 1 && !that.$store.state.goldindex) {

                that.global.ws.onmessage = that.onmessage
                
            }

        },

        // 挂单交易提交下单
        gdsubmit(){
            var that = this
            that.global.ws.onmessage = that.onmessage
            that.gdslsubmitflag = true
            var op = null //成交类型
            var stoploss = null // 止损参数
            var takeprofit = null //止盈参数

            var stoplimit = this.$store.state.mt == 5 && this.showts && this.silvertsprice?this.silvertsprice:0

            stoploss = that.gdsilverzs?that.gdsilverzs:(this.gdsilverzsds?that.getdstopricezs:0)
            takeprofit = that.gdsilverzy?that.gdsilverzy:(this.gdsilverzyds?that.getdstopricezy:0)
            that.choosetext == '限价买入'?0:(this.choosetext == '限价卖出'?1:(this.choosetext == '止损买入'?2:(this.choosetext == '止损卖出'?3:'')))
            
            op = that.choosetext == '限价买入'?2:(that.choosetext == '限价卖出'?3:(that.choosetext == '止损买入'?4:(that.choosetext == '止损卖出'?5:(that.choosetext == "停损限价买入"?6:(that.choosetext == "停损限价卖出"?7:"")))))

            var getdatetime = null

            if (that.global.ws && that.global.ws.readyState == 1 && that.gdslsubmitflag == true &&  that.navtabcurrentindex == 1) {

                that.loadingShow = true //开启加载提示

                    if(this.dealdatetext == '本日有效'){
                        getdatetime = moment().endOf('day').format('X')
                    }else if(this.dealdatetext == '本周有效'){
                        getdatetime = moment().endOf('week').format('X')
                    }else if(this.dealdatetext == '本月有效'){
                        getdatetime = moment().endOf('month').format('X')
                    }else if(this.dealdatetext == '长期有效'){
                        getdatetime = 0
                    }else{
                        getdatetime = Number(moment(this.dealdatetext).format("X"))
                    }

                sldealsj(this.$store.state.isprofession?'XAG':'SILVER',op,that.gdinitlot,stoploss,takeprofit,that.silvergdprice,getdatetime,that.global.ws,stoplimit)

            }
        },

        // 市价交易提交下单
        submit(){
            var that = this
            that.global.ws.onmessage = that.onmessage
            that.slsubmitflag = true
            var s = null //买入或卖出
            var stoploss = null // 止损参数
            var takeprofit = null //止盈参数

            s = that.sellBoxShow?1:(that.buyBoxShow?0:'')
            stoploss = that.silverzs?that.silverzs:(that.silverzsds?that.slgetsjdszs:0)
            takeprofit = that.silverzy?that.silverzy:(that.silverzyds?that.slgetsjdszy:0)

            if (that.global.ws && that.global.ws.readyState == 1 && that.slsubmitflag == true && that.navtabcurrentindex == 0) {

                that.loadingShow = true //开启加载提示

                sldealsj(this.$store.state.isprofession?'XAG':'SILVER',s,that.initlot,stoploss,takeprofit,0,0,that.global.ws,0)


 
            }
        },

        onmessage(evt){
            var data = atob(evt.data);
            var data2 = pako.inflateRaw(data);
            var arr = new Uint16Array(data2);
            var strData   = utf8ByteToUnicodeStr(arr);
            var silverobj = JSON.parse(strData)



            if(silverobj.act == 'order_send' && silverobj.success  && this.navtabcurrentindex == 0){


                this.$toast('下单成功')
                this.buyBoxShow = false //弹框
                this.sellBoxShow = false //弹框
                this.slsubmitflag = false //接受完数据关闭开关
                this.loadingShow = false //关闭加载提示

                this.$router.push({path:'/hold'})

            }else if(silverobj.act == 'order_send' && !silverobj.success  && this.navtabcurrentindex == 0){

                this.$toast(silverobj.msg)
                this.buyBoxShow = false //弹框
                this.sellBoxShow = false //弹框
                this.slsubmitflag = false //接受完数据关闭开关
                this.loadingShow = false //关闭加载提示
            }

            if(silverobj.act == 'order_send' && silverobj.success && this.navtabcurrentindex == 1){
                this.$toast('下单成功')

                this.timepickershow = false
                this.gdslsubmitflag = false
                this.gdshows = false
                this.loadingShow = false //关闭加载提示

                this.$router.push({path:'/pending-order'})

            }else if(silverobj.act == 'order_send' && !silverobj.success  && this.navtabcurrentindex == 1){
                this.$toast(silverobj.msg)
                this.timepickershow = false
                this.gdslsubmitflag = false
                this.gdshows = false
                this.loadingShow = false //关闭加载提示
            }

            // 全局订单推送
            if(silverobj.act == 'order_update'){

                if(this.$store.state.login){

                    this.$store.state.ordertipshow = true
                    
                    this.$store.state.ordertype = silverobj.msg.replace(/[0-9]/g,"")
    
                    this.$store.state.orderticket = silverobj.msg.replace(/[^\d.]/g,"");
                    this.$store.state.ordersymbol = silverobj.data.symbol
                    this.$store.state.orderdeal = silverobj.data.orderDirection
                    this.$store.state.orderopenprice = silverobj.data.openPrice
                    this.$store.state.ordercloseprice = silverobj.data.closePrice
                    this.$store.state.orderlots = silverobj.data.lots
                    this.$store.state.orderopentime = silverobj.data.openTime
                    this.$store.state.orderclosetime = silverobj.data.closeTime

                    setTimeout(() => {

                        this.$store.state.ordertipshow = false

                    }, 5000)
                }

            }
 
        },

        // 取消按钮
        btnremove(){
            this.sellBoxShow = false
            this.buyBoxShow = false 
            this.gdshows = false //挂单下单弹框
        },

    },
    watch:{

        // 通过store的专业者和非专业者监听预付款和挂单预付款初始值
        'isisprofession'(val){
            if(val){
                this.yfk = Number(this.yfk = this.gets(650,'initlot'))
                this.gdyfk = Number(this.gdyfk = this.gets(650,'gdinitlot'))
            }else{
                this.yfk = Number(this.yfk = this.initlot * 100 * this.$store.state.silverBuy)
                this.gdyfk = Number(this.gdyfk = this.gdinitlot * 100 * this.silvergdprice)
            }
        },
        
        'silvergdprice'(val){
            if(val){
                val = parseFloat(val).toFixed(3)
            }

        }
    },
    computed:{

        ...mapGetters([
            'isisprofession'
        ]),

        // 计算买入市场价和卖出市场价点差
        spread(){
            return ((this.$store.state.silverBuy - this.$store.state.silverSell) * 1000).toFixed(0)
        },

        // 计算挂单停损限价价格
        silveryjtsprice(){
            if(this.silvergdprice){
                if(this.choosetext == "停损限价买入"){
                    return "<" + (Number(this.silvergdprice) - (this.$store.state.silverstopsLevel/1000)).toFixed(3)
                }else if(this.choosetext == "停损限价卖出"){
                    return ">" + (Number(this.silvergdprice) + (this.$store.state.silverstopsLevel/1000)).toFixed(3)
                }
            }else{
                return null
            }
        },

        // 计算挂单白银交易类型跳动价格
        getDealTypePrice(){
            if(this.choosetext == '限价买入'){
                // 买入市价-$2.00
                return '<' + ((this.$store.state.silverBuy - (this.$store.state.silverstopsLevel/1000)).toFixed(3))
            }else if(this.choosetext == '限价卖出'){
                // 卖出市价+$2.00
                return '>' + ((this.$store.state.silverSell + (this.$store.state.silverstopsLevel/1000)).toFixed(3))
            }else if(this.choosetext == '止损买入'){
                // 买入市价+$2.00
                return '>' + ((this.$store.state.silverBuy + (this.$store.state.silverstopsLevel/1000)).toFixed(3))
            }else if(this.choosetext == '止损卖出'){
                // 卖出市价-$2.00
                return '<' + ((this.$store.state.silverSell - (this.$store.state.silverstopsLevel/1000)).toFixed(3))
            }else if(this.choosetext == "停损限价买入"){
                return '>' + ((this.$store.state.silverBuy + (this.$store.state.silverstopsLevel/1000)).toFixed(3))
            }else if(this.choosetext == "停损限价卖出"){
                return '<' + ((this.$store.state.silverSell - (this.$store.state.silverstopsLevel/1000)).toFixed(3))
            }
        },

        // 计算市价下单止盈止损点数换算成价格
        slgetsjdszs(){
            if(this.buyBoxShow){
                 return this.Sub(this.$store.state.silverBuy,(this.silverzsds / 1000).toFixed(3))
            }else if(this.sellBoxShow){
                return this.NumberAdd(this.$store.state.silverSell,(this.silverzsds / 1000).toFixed(3))
            }
        },

        slgetsjdszy(){
            if(this.buyBoxShow){
                return this.NumberAdd(this.$store.state.silverBuy,(this.silverzyds / 1000).toFixed(3))
            }else if(this.sellBoxShow){
                return this.Sub(this.$store.state.silverSell,(this.silverzyds / 1000).toFixed(3))
            }
        },

        // 计算下单止盈止损点数换算成价格
        getdstopricezs(){
                if(this.$store.state.sldealtype == '限价买入'){

                    return this.Sub(this.silvergdprice,(this.gdsilverzsds / 1000).toFixed(3)) //白银页面挂单弹出框的止损点数转换成止损价格

                }else if(this.$store.state.sldealtype == '限价卖出'){

                    return this.NumberAdd(this.silvergdprice,(this.gdsilverzsds / 1000).toFixed(3)) //白银页面挂单弹出框的止损点数转换成止损价格

                }else if(this.$store.state.sldealtype == '止损买入'){

                    return this.Sub(this.silvergdprice,(this.gdsilverzsds / 1000).toFixed(3)) //白银页面挂单弹出框的止损点数转换成止损价格

                }else if(this.$store.state.sldealtype == '止损卖出'){

                    return this.NumberAdd(this.silvergdprice,(this.gdsilverzsds / 1000).toFixed(3)) //白银页面挂单弹出框的止损点数转换成止损价格

                }else if(this.$store.state.sldealtype == "停损限价买入"){

                   return this.Sub(this.silvertsprice,(this.gdsilverzsds / 1000).toFixed(3)) //白银页面挂单弹出框的止损点数转换成止损价格

                }else if(this.$store.state.sldealtype == "停损限价卖出"){

                   return this.NumberAdd(this.silvertsprice,(this.gdsilverzsds / 1000).toFixed(3)) //白银页面挂单弹出框的止损点数转换成止损价格

                }
        },

        getdstopricezy(){
                if(this.$store.state.sldealtype == '限价买入'){

                    return this.NumberAdd(this.silvergdprice,(this.gdsilverzyds / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格

                }else if(this.$store.state.sldealtype == '限价卖出'){

                    return this.Sub(this.silvergdprice,(this.gdsilverzyds / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格

                }else if(this.$store.state.sldealtype == '止损买入'){

                    return this.NumberAdd(this.silvergdprice,(this.gdsilverzyds / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格

                }else if(this.$store.state.sldealtype == '止损卖出'){

                    return this.Sub(this.silvergdprice,(this.gdsilverzyds / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格
                    
                }else if(this.$store.state.sldealtype == "停损限价买入"){

                    return this.NumberAdd(this.silvertsprice,(this.gdsilverzyds / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格
                    
                }else if(this.$store.state.sldealtype == "停损限价卖出"){

                    return this.Sub(this.silvertsprice,(this.gdsilverzyds / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格
                    
                }
        },

    },
    mounted(){
        this.initWebpack()
    }
}
</script>

<style scoped>
    body{touch-action: none;}
    li{list-style: none;}
    .mask{background: #000000;width: 100%;height: 100%;opacity: 0.4;position: fixed;left: 0;top: 0;z-index: 887;}
    .content{background: #FFFFFF;}
    .navbox{background-color: #FFFFFF;margin: 0 auto;}
    .nav{width: 200px;height: 32px;display: flex;align-items: center;margin: 0 auto;padding: 12px 0;}
    .nav p{flex: 1;display: flex;justify-content: center;align-items: center;font-size: 14px;}
    .nav p:nth-of-type(1){border-top-right-radius: 0;border-bottom-right-radius: 0;}
    .nav p{height: 100%; border: 1px solid #FF4F36;color: #FF4F36;border-radius: 15.83px;}
    .nav p:nth-of-type(2){border-top-left-radius: 0;border-bottom-left-radius: 0;}
    .navactived{background-color: #FF4F36 !important;color: #FFFFFF !important;}
    .content .contenttips{color: #BBBBBB;font-size: 12px;text-align: center;padding-bottom: 16px;}
    .content .price{margin: 0 auto;display: flex;justify-content: center;align-items: center;}
    .content .price .left{display: flex;text-align: center;flex-direction: column;}
    .content .price .left p:nth-of-type(1){color: #999999;font-size: 14px;}
    .content .price .left p:nth-of-type(2){color: #17CF84;font-size: 24px;font-weight: bold;}
    .content .price .main{color: #BBBBBB;font-size: 12px;width: 60px;height: 44px;background-color: #F8F8F8;display: flex;flex-direction: column;justify-content: center;align-items: center;margin: 0 31.33px;}
    .content .price .right{display: flex;text-align: center;flex-direction: column;}
    .content .price .right p:nth-of-type(1){color: #999999;font-size: 14px;}
    .content .price .right p:nth-of-type(2){color: #FF4F36;font-size: 24px;font-weight: bold;}
    
    .content .dealbox{height: 50px;display: flex;justify-content: space-between;align-items: center;margin: 0 16px;border-bottom: 1px solid #EEEEEE;margin-bottom: 13px;}
    .content .dealbox .ctrlbox{flex: 1;display: flex;justify-content: flex-end;}
    .content .dealbox .left{display: flex;align-items: center;flex: 1;}
    .content .dealbox .left p{color: #333333;font-size: 14px;}
    .content .dealbox .left p span{color: #999999;padding-left: 9px;font-size: 12px;}
    .content .dealbox .main img{width: 24px;height: 24px;display: block;margin-left: 15px;}
    .content .dealbox .right{display: flex;justify-content: center;align-items: center;}
    .content .dealbox .right img{width: 24px;height: 24px;display: block;margin-right: 10.33px;}
    .content .dealbox .right span:nth-of-type(1){flex: 1;width: 88px;}
    .content .dealbox .right span:nth-of-type(1) input{text-align: center; color: #333333 !important;font-size: 16px !important;font-weight: bold !important;width: 100%;border: none;outline: none;}
    .content .dealbox .right span:nth-of-type(3){color: #999999;font-size: 14px;}

    .content .buybox{height: 44px;margin: 0 15px auto;display: flex;justify-content: space-between;align-items: center;margin-top: 15px;padding-bottom: 100px;}
    .content .buybox .sell{width: 48.3%; height: 44px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 16px;background-color: #17CF84;border-radius: 22px;}
    .content .buybox .buy{width: 48.3%; height: 44px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 16px;background-color: #FF4F36;border-radius: 22px;}

    /* 挂单交易 */
    .list{padding: 0 15px;}
    .list-item{border-bottom: 1px solid #EEEEEE;height: 44px;display: flex;justify-content: space-between;align-items: center;color: #333333;font-size: 14px;}
    .list-item-left{display: flex;justify-content: flex-start;align-items: center;}
    .list-item-left span{color: #999999;font-size: 12px;padding-left: 8px;}
    .list-item-right{font-weight: bold;display: flex;justify-content: space-between;align-items: center;}
    .list-item-right span img{width: 16px;height: 16px;display: block;margin-top: 2px;}

    .list-item-right {height: 50px;display: flex;justify-content: space-between;align-items: center;}
    .list-item-right  .left{display: flex;align-items: center;}
    .list-item-right  .left p{color: #333333;font-size: 14px;}
    .list-item-right  .left p span{color: #999999;padding-left: 9px;font-size: 12px;}
    .list-item-right  .main img{width: 24px;height: 24px;display: block;}
    .list-item-right  .right{display: flex;justify-content: center;align-items: center;}
    .list-item-right  .right img{width: 24px;height: 24px;display: block;margin-right: 10.33px;}
    .list-item-right  .right span:nth-of-type(1){color: #BBBBBB;font-size: 16px;font-weight: bold;width: 55px;padding:0 22px;}
    .list-item-right  .right span:nth-of-type(3){color: #999999;font-size: 14px;text-align: right;}
    .list-item-right input{text-align: center; color: #333333 !important;font-size: 16px !important;font-weight: bold !important;width: 100%;border: none;outline: none;}

    .xiadanbtn{margin: 15px 15px 0px 15px;height: 44px;background-image: linear-gradient(to right,#FF6738,#FF4F36);border-radius: 22px;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 16px;}

    /* 买卖弹出框 */
    .Sellbox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;left: 0;right: 0;bottom: 0;z-index: 888;}
    .Sellbox .title{text-align: center;padding: 17px 0;font-weight: bold;}
    .Sellbox .sellContent{margin: 0 15px 15px 15px;background-color: #F8F8F8;border-radius: 12px;}
    .Sellbox .sellContent .top{padding: 12px 0 6px 12px;display: flex;justify-content: flex-start;align-items: center;}
    .Sellbox .sellContent .top span:nth-of-type(1){padding: 2px 4px;height: 18px;border-radius: 9px;background-color: #17CF84;display: block;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 12px;}
    .Sellbox .sellContent .top span:nth-of-type(2){font-size: 16px;color: #333333;font-weight: bold;padding-left: 6.67px;}
    .Sellbox .sellContent .top span:nth-of-type(3){font-size: 16px;color: #333333;font-weight: bold;padding-left: 9.33px;}
    .Sellbox .sellContent ul{padding: 0 0 18px 11.67px;display: flex;justify-content: flex-start;align-items: center;}
    .Sellbox .sellContent ul .right{padding-left: 49px;}
    .Sellbox .sellContent ul li{font-size: 14px;color: #999999;padding-top: 6px;}
    .Sellbox .sellContent ul li span{color: #333333;padding-left: 10.33px;}
    .Sellbox .sellbtn{padding: 0 15px 49px 15px;display: flex;justify-content: space-between;align-items: center;}
    .sellbtn p{width: 48.9%;height: 44px;border-radius: 22px;display: flex;justify-content: center;align-items: center;font-weight: bold;}
    .sellbtn p:nth-of-type(1){color: #333333;background-color: #EEEEEE;}
    .sellbtn p:nth-of-type(2){color: #FFFFFF;background-image: linear-gradient(to right, #FF4F36, #FF6738);}

    /* 选择交易类型 */
    .chooseTpbox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;left: 0;right: 0;bottom: 0;z-index: 888;padding-bottom: 49px;}
    .chooseTpbox .title{text-align: center;padding: 17px 0;font-weight: bold;}
    .chooseTpbox .title .close{width: 24px;height: 24px;display: block;position: absolute;left: 15.33px;top: 13px;}
    .chooseTpbox .list{padding-left: 20.33px;}
    .chooseTpbox .list .item{border-bottom: 1px solid #F5F5F5;height: 56.33px;display: flex;justify-content: space-between;align-items: center;color: #333333;font-size: 16px;}
    .chooseTpbox .list .item img{width: 24px;height: 24px;display: block;}

    /* 选择交易日期 */
    .databox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;left: 0;right: 0;bottom: 0;z-index: 888;padding-bottom: 49px;}
    .databox .title{text-align: center;padding: 17px 0;font-weight: bold;}
    .databox .title .close{width: 24px;height: 24px;display: block;position: absolute;left: 15.33px;top: 13px;}
    .databox .list{padding-left: 20.33px;}
    .databox .list .item{border-bottom: 1px solid #F5F5F5;height: 56.33px;display: flex;justify-content: space-between;align-items: center;color: #333333;font-size: 16px;}
    .databox .list .item img{width: 24px;height: 24px;display: block;}

    /* timepicer */
    .timebox{background-color: #FFFFFF;position: fixed;bottom: 0;width: 100%;z-index: 99999;border-top-left-radius:12px;border-top-right-radius: 12px;}
    .timeboxwrapper{padding: 0 32px;background-color: #FFFFFF;margin-top: 10px;}
    .timeboxwrapper .title{color: #333333;font-weight: bold;font-size: 16px;text-align: center;padding: 17.67px 0 32px 0;}
    .timebox ul{display: flex;}
    .timebox ul li{padding: 0 4px;flex: 1;display: flex;justify-content: center;color:#BBBBBB;font-size: 16px;}
    .timebtn{padding: 0 20px; margin:0 auto;display: flex;justify-content: space-between;align-items: center;margin-top: 25px;margin-bottom: 40px;}
    .timebtn p:nth-of-type(1){width: 48.3%;height: 44px;font-weight: bold;color: #333333;font-size: 16px;display: flex;justify-content: center;align-items: center;border-radius: 22px;background-color: #EEEEEE;}
    .timebtn p:nth-of-type(2){width: 48.3%;height: 44px;font-weight: bold;color: #FFFFFF;font-size: 16px;display: flex;justify-content: center;align-items: center;border-radius: 22px;background-image: linear-gradient(to bottom, #FF6738, #FF4F36);}

    /* 加载loading */
    .isloginTips{width: 150px;border-radius: 9px;background: rgba(0, 0, 0, 0.6);position: fixed;left: 0;right: 0;top: 40%;z-index: 888;color: #FFFFFF;font-weight: bold;font-size: 14px;text-align: center;line-height: 60px;margin: 0 auto;display: flex;justify-content: center;align-items: center;flex-direction: column;}
    .isloginTips p{height: 50px;display: flex;align-items: center;}
    .isloginTips img{width: 40px;height: 40px;display: block;margin-top: 20px;animation:loading 0.75s linear infinite forwards;}
    @keyframes loading {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
</style>


// WEBPACK FOOTER //
// src/components/silver.vue